<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title is-size-5-desktop is-size-6-mobile">
                {{ title }}
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <p class="is-size-3-desktop is-size-5-mobile" :class="bodyClasses">{{ body }}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "DataCard",
  props: {
    title: {
        type: String,
        required: true
    },
    body: {
        type: String,
        required: true
    },
    bodyClasses: {
        type: String,
        required: true
    }
  }
};

</script>

<style scoped>

.card {
    height: 100%;
}

</style>